import { gql, type TypedDocumentNode } from '@apollo/client';

import type { NotificationList, NotificationPreference } from '../types/notifications.types';

/** The fields the bell renders — deliberately no delivery status or channels (the Worker's concern). */
const NOTIFICATION_FIELDS = `
  id
  title
  body
  type
  priority
  isRead
  readAt
  deepLink
  metadata
  createdAt
`;

export interface NotificationsVariables {
  unreadOnly: boolean;
  page: number;
  pageSize: number;
}

/** The signed-in user's notifications, newest first — scope is forced to the actor server-side. */
export const NOTIFICATIONS_QUERY: TypedDocumentNode<
  { notifications: NotificationList | null },
  NotificationsVariables
> = gql`
  query Notifications($unreadOnly: Boolean!, $page: Int!, $pageSize: Int!) {
    notifications(unreadOnly: $unreadOnly, page: $page, pageSize: $pageSize) {
      items { ${NOTIFICATION_FIELDS} }
      totalCount
      page
      pageSize
      totalPages
      hasNextPage
      hasPreviousPage
    }
  }
`;

/** The unread count behind the bell badge. */
export const UNREAD_NOTIFICATION_COUNT_QUERY: TypedDocumentNode<
  { unreadNotificationCount: number },
  Record<string, never>
> = gql`
  query UnreadNotificationCount {
    unreadNotificationCount
  }
`;

/** The signed-in user's effective notification preferences — one entry per type, for the settings page. */
export const MY_NOTIFICATION_PREFERENCES_QUERY: TypedDocumentNode<
  { myNotificationPreferences: NotificationPreference[] },
  Record<string, never>
> = gql`
  query MyNotificationPreferences {
    myNotificationPreferences {
      type
      inAppEnabled
      emailEnabled
      isMandatory
    }
  }
`;
